module.exports = __webpack_public_path__ + "img/banner3_1_kr.4bdd44f4.png";